module.exports = __webpack_public_path__ + "img/img1.9f61c23d.jpg";